// extracted by mini-css-extract-plugin
export var closeButton = "_6r-0";